import { render } from "./Success-popup.vue?vue&type=template&id=97290808&scoped=true"
import script from "./Success-popup.vue?vue&type=script&lang=js"
export * from "./Success-popup.vue?vue&type=script&lang=js"

import "./Success-popup.vue?vue&type=style&index=0&id=97290808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97290808"]])

export default __exports__